export default __webpack_public_path__ + "static/media/vortexofthestorm.59635ae9.jpg";